"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.currentPathToLocale = exports.localizedLink = exports.localizeHref = exports.setLocaleFromRoute = exports.localizedRoutes = void 0;
var mithril_1 = __importDefault(require("mithril"));
var i18n_1 = require("./i18n");
var localeParam = 'locale';
function localizedRoutes(routes) {
    var result = {};
    Object.keys(routes).forEach(function (path) {
        result['/:' + localeParam + path] = routes[path];
    });
    return result;
}
exports.localizedRoutes = localizedRoutes;
function setLocaleFromRoute() {
    var routeLocale = mithril_1.default.route.param(localeParam);
    if (routeLocale === i18n_1.i18n.currentLocale) {
        return;
    }
    if (i18n_1.i18n.supported(routeLocale)) {
        i18n_1.i18n.loadAndSetLocale(routeLocale);
    }
    else {
        mithril_1.default.route.set("/".concat(i18n_1.i18n.defaultLocale));
    }
}
exports.setLocaleFromRoute = setLocaleFromRoute;
function localizeHref(href) {
    return '/' + i18n_1.i18n.currentLocale + href;
}
exports.localizeHref = localizeHref;
/**
 * `localizedLink("/uri", children)`
 * or
 * `localizedLink("/uri", attrs, children)`
 * @param {string} href
 * @returns Vnode
 */
function localizedLink(href) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var _a = (args.length === 1 ? [{}, args[0]] : args), attrs = _a[0], children = _a[1];
    return (0, mithril_1.default)(mithril_1.default.route.Link, __assign(__assign({}, attrs), { href: localizeHref(href) }), children);
}
exports.localizedLink = localizedLink;
function currentPathToLocale(newLocale) {
    var pathParts = mithril_1.default.route.get().split('/');
    pathParts[1] = newLocale;
    return pathParts.join('/');
}
exports.currentPathToLocale = currentPathToLocale;
//# sourceMappingURL=i18nRouting.js.map